export default function Header() {
	return (
			<header className="App-header">
				<h1>Party party</h1>
			</header>
	);
}
